import Modal from "../../Modal";
import Card from "../../Card";

interface PopupProps {
  modalopen: boolean;
  item: any;
  handleModalClose: () => void;
}

const Popup: React.FC<PopupProps> = ({ item, modalopen, handleModalClose }) => {
  return (
    <Modal
      className="w-96 model p-4"
      visible={modalopen}
      onClose={handleModalClose}
    >
      <Card property={item} />
    </Modal>
  );
};
export default Popup;
